export const TrackInsertMarkName = 'trackInsert';
export const TrackDeleteMarkName = 'trackDelete';
export const TrackFormatMarkName = 'trackFormat';

/**
 * Marks that should be represented as tracked formatting changes in suggesting mode.
 * These are the marks that contribute visible formatting or inline semantics.
 */
export const TrackedFormatMarkNames = ['bold', 'italic', 'strike', 'underline', 'textStyle', 'highlight', 'link'];
